{
  "action": {
    "label": "Action"
  },
  "actionType": {
    "label": "Type d’action",
    "value": {
      "alert": "Alerte",
      "dvtm": "DVTM",
      "external_platform": "Platforme externe",
      "group": "Groupe",
      "iam": "IAM",
      "platform": "Platforme",
      "profile": "Profil",
      "sector": "Secteur",
      "talq_gateway": "Passerelle TALQ",
      "user": "Utilisateur"
    }
  },
  "export": {
    "error": "Une erreur s’est produite lors de la génération du fichier CSV",
    "label": "Exporter",
    "tooltip": "Sélectionner des lignes pour pouvoir les exporter au format CSV"
  },
  "eventType": {
    "label": "Type d’évènement",
    "value": {
      "cyber": "Cyber",
      "device": "Équipement",
      "device_fleet": "Parc d’équipements",
      "system": "Système"
    }
  },
  "level": {
    "label": "Niveau d’info.",
    "value": {
      "info": "Information",
      "warning": "Alerte",
      "error": "Erreur",
      "critical": "Critique"
    }
  },
  "timestamp": {
    "label": "Horodatage"
  },
  "filters": {
    "actions": {
      "placeholder": "Rechercher par action",
      "empty": "Aucune action n’a été trouvée",
      "actionFound": "Aucune action n'a été trouvée | {count} action trouvée | {count} actions trouvées"
    },
    "applications": {
      "declination": {
        "empty": "Aucune application"
      },
      "label": "Application",
      "placeholder": "Rechercher par application",
      "type": {
        "empty": "Aucun type"
      }
    },
    "clear": {
      "label": "Supprimer les filtres"
    },
    "componentId": {
      "label": "Identifiant de composant",
      "value": {
        "all": "Tous"
      }
    },
    "dropdown": {
      "applyAsAFilter": "Appliquer comme filtre",
      "button": {
        "label": "Filtres",
        "title": "Afficher les filtres"
      },
      "properties": {
        "device": "Propriétés de l’équipement",
        "email_address": "Propriétés de l’email",
        "gateway": "Propriétés de la passerelle",
        "group": "Propriétés du groupe",
        "platform": "Propriétés de la plateforme",
        "profile": "Propriétés du profil",
        "sector": "Propriétés du secteur",
        "user": "Propriétés de l’utilisateur",
        "pki_config": "Propriétés de la PKI",
        "interface": "Propriétés de l'interface"
      }
    },
    "entityClass": {
      "label": "Catégorie d’auteur ou d’actif",
      "value": {
        "device": "Équipement",
        "email_address": "Adresse e-mail",
        "gateway": "Passerelle",
        "group": "Groupe",
        "platform": "Plateforme",
        "profile": "Profil",
        "role": "Rôle",
        "sector": "Secteur",
        "user": "Utilisateur"
      }
    },
    "entity": {
      "label": "Auteur ou actif"
    },
    "sortBy": {
      "label": "Tri",
      "value": {
        "datetime": "Chronologique"
      }
    },
    "sortDirection": {
      "label": "Ordre",
      "value": {
        "asc": "Croissant",
        "desc": "Décroissant"
      }
    },
    "startDate": {
      "label": "Date de début"
    },
    "status": {
      "label": "Erreur"
    },
    "timestamp": {
      "formatter": "DD/MM/YYYY",
      "periodSeparator": "au",
      "placeholder": "Sélectionnez une période"
    },
    "users": {
      "placeholder": "Rechercher des utilisateurs"
    },
    "devices": {
      "model": {
        "empty": "Aucun modèle"
      },
      "type": {
        "empty": "Aucun type"
      }
    },
    "actionTypes": {
      "placeholder": "Rechercher des types d'action",
      "empty": "Aucun type d'action n'a été trouvé",
      "actionTypesFound": "Aucun type d'action n'a été trouvé | {count} type d'action trouvé | {count} types d'action trouvés"
    }
  },
  "list": {
    "column": {
      "timestamp": {
        "format": "DD/MM/YYYY HH:mm:ss"
      },
      "label": {
        "label": "Libellé"
      }
    },
    "empty": "Aucun enregistrement de log n’a été trouvé",
    "unknown": "inconnu"
  },
  "origin": {
    "label": "Origine",
    "values": {
      "mobileApplication": "Application mobile",
      "device": "Équipement",
      "thirdPartyApplication": "Application tierce",
      "lxConnect": "LX CONNECT"
    }
  }
}
